// extracted by css-extract-rspack-plugin
export default {"logo":"gboY_M"};